<template>
  <div class="bg-card relative inline-flex items-center gap-0.5 rounded-lg border p-1 shadow-sm">
    <Tooltip>
      <TooltipTrigger as-child>
        <button
          type="button"
          :class="[
            theme === 'light'
              ? 'bg-primary text-primary-foreground shadow-sm'
              : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
          ]"
          class="focus-visible:ring-ring relative flex h-7 w-7 items-center justify-center rounded-md transition-all duration-200 focus-visible:ring-2 focus-visible:outline-none"
          @click="updateTheme('light')"
        >
          <SunIcon :size="16" />
        </button>
      </TooltipTrigger>
      <TooltipContent>Light</TooltipContent>
    </Tooltip>

    <Tooltip>
      <TooltipTrigger as-child>
        <button
          type="button"
          :class="[
            theme === 'dark'
              ? 'bg-primary text-primary-foreground shadow-sm'
              : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
          ]"
          class="focus-visible:ring-ring relative flex h-7 w-7 items-center justify-center rounded-md transition-all duration-200 focus-visible:ring-2 focus-visible:outline-none"
          @click="updateTheme('dark')"
        >
          <MoonIcon :size="16" />
        </button>
      </TooltipTrigger>
      <TooltipContent>Dark</TooltipContent>
    </Tooltip>

    <Tooltip>
      <TooltipTrigger as-child>
        <button
          type="button"
          :class="[
            theme === 'system'
              ? 'bg-primary text-primary-foreground shadow-sm'
              : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
          ]"
          class="focus-visible:ring-ring relative flex h-7 w-7 items-center justify-center rounded-md transition-all duration-200 focus-visible:ring-2 focus-visible:outline-none"
          @click="updateTheme('system')"
        >
          <MonitorIcon :size="16" />
        </button>
      </TooltipTrigger>
      <TooltipContent>System</TooltipContent>
    </Tooltip>
  </div>
</template>

<script setup lang="ts">
import { MonitorIcon, MoonIcon, SunIcon } from 'lucide-vue-next';
import { onMounted, ref } from 'vue';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/ui/tooltip';

const theme = ref();

const updateTheme = (_theme = 'system') => {
  if (_theme === 'system') {
    document.documentElement.setAttribute(
      'data-theme',
      window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light',
    );
  } else {
    document.documentElement.setAttribute('data-theme', _theme);
  }

  window.localStorage.setItem('theme', _theme);

  theme.value = _theme;
};

onMounted(() => {
  theme.value = window.localStorage.getItem('theme');
});
</script>
